// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const couldBeNumber = (v?: any) => isFinite(v) && !isNaN(parseFloat(v));
